import { Component, HostListener, inject, input, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { ScreenSizeService } from '@core/services';

@Component({
  selector: 'app-spa-paynet-wallet',
  imports: [RouterOutlet],
  template: `<router-outlet />`,
  styleUrl: './app.scss',
})
export class App implements OnInit {
  readonly route = input.required<string>();
  readonly params = input<string | null>(null);

  private router = inject(Router);
  private screenSizeService = inject(ScreenSizeService);
  constructor() {}

  ngOnInit(): void {
    this.screenSizeService.checkScreenSize();
    const route = this.route();
    console.log('Input: ', route);

    // сверху отдавайте params=
    if (this.params()) {
      this.router.navigate([route], {
        state: { params: this.params() },
        skipLocationChange: true,
      });
    }
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.screenSizeService.checkScreenSize();
  }
}
